<template>
	<div class="device-detail">
		<div class="button" v-if="isMap">
			<div class="deta" :class="{ detailActive: isDetail == 'detail' }" @click="changeDetail('detail')">
				{{$t('terminal.deviceDetail')}}
			</div>
			<div class="playlisty" :class="{ detailActive: isDetail == 'list' }" @click="changeDetail('list')">
				{{$t('terminal.playList')}}
			</div>
		</div>
		<template v-if="isDetail=='detail'">
			<div class="caputer" :class="{mapCaputer:!isMap}">
				<div class="img" v-loading="imgloading" :element-loading-text="$t('terminal.loading')"
					v-if="currentDetail.run_state" element-loading-spinner="el-icon-loading"
					element-loading-background="rgba(0, 0, 0, 0.8)">
					<el-image style="width: 100%; height: 100%; z-index: 1000" :z-index="20000" :src="detailImg"
						fit="contain" class="elimg" ref="pimg">
					</el-image>
				</div>
				<div class="img" v-else></div>
			</div>
			<div class="details" :class="{isMap:!isMap}" v-loading="detailLoading">
				<div class="b_border" :class="{b_border_map:!isMap}">
					<el-tooltip effect="dark" :content="$t('terminal.deviceName')" placement="top-start">
						<div class="text">{{$t('terminal.deviceName')}}：</div>
					</el-tooltip>
					<el-tooltip class="item" effect="dark" :content="currentDetail.name" placement="top-start">
						<div class="content">{{ currentDetail.name }}</div>
					</el-tooltip>
				</div>
				<div class="b_border" :class="{b_border_map:!isMap}" v-if="!isMap">
					<div class="text">{{$t('terminal.affi')}}</div>
					<div class="content">{{ currentDetail.group_name }}</div>
				</div>
				<!-- <div class="b_border" :class="{b_border_map:!isMap}" v-if="isMap">
					<div class="text">{{$t('terminal.screenType')}}</div>
					<div class="content">{{ currentDetail.type_remark }}</div>
				</div> -->
				<div class="b_border">
					<div class="text">{{$t('terminal.resolution')}}：</div>
					<div class="content">{{ currentDetail.size_remark }}</div>
				</div>

				<div class="b_border" v-if="currentDetail.remark1 != ''">
					<div class="text">{{$t('terminal.remark')}}：</div>
					<div class="content">{{ currentDetail.remark1 }}</div>
				</div>
				<div class="b_border" v-else>
					<div class="text">{{$t('terminal.remark')}}：</div>
					<div class="content">{{$t('terminal.noData')}}</div>
				</div>
				<div class="b_border" v-if="isMap">
					<div class="text">{{$t('terminal.boxTime')}}：</div>
					<template v-if="this.currentDetail.time!=null&&this.currentDetail.time!=''">
						<el-tooltip class="item" effect="dark" :content="currentDetail.time" placement="top-start">
							<div class="content">
								{{ currentDetail.time }}
							</div>
						</el-tooltip>
					</template>
					<div class="content" v-else>{{$t('terminal.noData')}}</div>
				</div>
				<div class="b_border" v-if="isMap">
					<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.currTimeZone')"
						placement="top-start">
						<div class="text">{{$t('terminal.currTimeZone')}}：</div>
					</el-tooltip>
					<template v-if="this.timeUTC==-1">
						<div class="content">{{$t('terminal.noData')}}</div>
					</template>
					<template v-else>
						<el-tooltip class="item" effect="dark" :content="this.timeUTC" placement="top-start">
							<div class="content">
								{{ this.timeUTC }}
							</div>
						</el-tooltip>
					</template>
				</div>
				<div class="b_border" v-if="isMap">
					<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.deviceLan')"
						placement="top-start">
						<div class="text">{{$t('terminal.deviceLan')}}：</div>
					</el-tooltip>
					<div class="content">
						<template v-if="!currentDetail.deviceLan">
							{{$t('terminal.noData')}}
						</template>
						<template v-else>
							{{currentDetail.deviceLan}}
						</template>
					</div>
				</div>
				<template v-if="isMap">
					<div class="b_border" v-if="currentDetail.totalSpace != 0">
						<div class="text">{{$t('terminal.deviceZoom')}}：</div>
						<div class="content">
							{{`${(currentDetail.usableSpace / 1024).toFixed(2)}G / ${(currentDetail.totalSpace / 1024).toFixed(2)}G`}}
						</div>
					</div>
					<div class="b_border" v-else>
						<div class="text">{{$t('terminal.deviceZoom')}}：</div>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div>
				</template>
				<template v-if="isMap">
					<div class="b_border"
						v-if="currentDetail.system_version != null &&currentDetail.type_remark!='Kommander'">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.version')"
							placement="top-start">
							<div class="text">{{$t('terminal.version')}}：</div>
						</el-tooltip>
						<div class="content">
							V{{ currentDetail.system_version }}
						</div>

					</div>
					<div class="b_border" v-else>
						<div class="text">{{$t('terminal.version')}}：</div>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div>
				</template>
				<div class="b_border">
					<div class="text">{{$t('terminal.runState')}}：</div>
					<div class="content">
						<span
							:style="'color:' + currentDetail.runStateInfo.stateColor">{{ $t(currentDetail.runStateInfo.stateName) }}</span>
					</div>
				</div>
				<div class="b_border">
					<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.runTime')"
						placement="top-start">
						<div class="text">{{$t('terminal.runTime')}}：</div>
					</el-tooltip>
					<template v-if="currentDetail.uptimeMills == '暂无数据'">
						<div class="content">{{$t('terminal.noData')}}</div>
					</template>
					<template v-else>
						<div class="content">{{ currentDetail.uptimeMills }}</div>
					</template>
				</div>
				<div class="b_border">
					<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.lastHeart')"
						placement="top-start">
						<div class="text">{{$t('terminal.lastHeart')}}：</div>
					</el-tooltip>
					<template v-if="currentDetail.last_heartbeat!='-1'">
						<el-tooltip class="item" effect="dark" :content="currentDetail.last_heartbeat.toString()"
							placement="top-start">
							<div class="content">{{ currentDetail.last_heartbeat }}</div>
						</el-tooltip>
					</template>
					<template v-else>
						<div class="content">{{$t('terminal.noData')}}</div>
					</template>
				</div>
				<template v-if="isMap">
					<div class="b_border"
						v-if="currentDetail.timeOnOff == undefined ||currentDetail.timeOnOff.length == 0">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.timeOrder')"
							placement="top-start">
							<div class="text">{{$t('terminal.timeOrder')}}：</div>
						</el-tooltip>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div>
					<div class="b_border" v-else>
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.timeOrder')"
							placement="top-start">
							<div class="text">{{$t('terminal.timeOrder')}}：</div>
						</el-tooltip>
						<div class="content">{{$t('terminal.open')}}</div>
					</div>
					<div class="b_border" v-if="currentDetail.remote_addr!=''">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.comAddr')"
							placement="top-start">
							<div class="text">{{$t('terminal.comAddr')}}：</div>
						</el-tooltip>
						<div class="content">{{currentDetail.remote_addr}}</div>
					</div>
					<div class="b_border" v-else>
						<div class="text">{{$t('terminal.comAddr')}}：</div>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div>

					<div class="b_border"
						v-if="currentDetail.sign_input !== undefined && currentDetail.sign_input !== 0">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.signalStatus')"
							placement="top-start">
							<div class="text">{{$t('terminal.signalStatus')}}：</div>
						</el-tooltip>
						<div class="content">
							<template v-if="currentDetail.sign_input == 1">
								{{$t('terminal.acVa3')}}
							</template>
							<template v-if="currentDetail.sign_input == 2">
								{{$t('terminal.acVa2')}}
							</template>
							<template v-if="currentDetail.sign_input == 3">
								{{$t('terminal.acVa1')}}
							</template>
						</div>
					</div>
					<div class="b_border" v-else>
						<div class="text">{{$t('terminal.signalStatus')}}：</div>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div>

					<!-- <div class="b_border" v-if="currentDetail.timing_play!=''">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.timingPlay')" placement="top-start">
							<div class="text">{{$t('terminal.timingPlay')}}：</div>
						</el-tooltip>
						<div class="content">{{currentDetail.timing_play}}</div>
					</div>
					<div class="b_border" v-else>
						<div class="text">{{$t('terminal.timingPlay')}}：</div>
						<div class="content">{{$t('terminal.noData')}}</div>
					</div> -->
					<div class="block">
						<div class="text">
							{{$t('terminal.voice')}}：
						</div>
						<div class="content">
							<div class="slider">
								<el-slider v-model="voice" @change="changeVoice" style="margin-right: 10px"
									:disabled="!currentDetail.run_state">
								</el-slider>
							</div>
							<div class="input">
								<el-input-number class="input" size="mini" v-model="cvoice" controls-position="right"
									@change="changeCvoice" :min="0" :max="100" :disabled="!currentDetail.run_state">
								</el-input-number>
							</div>
						</div>
					</div>
					<div class="block">
						<el-tooltip effect="dark" class="ellipsis-1" :content="$t('terminal.birght')"
							placement="top-start">
							<div class="text">
								<span style="white-space: nowrap">{{$t('terminal.birght')}}：</span>
							</div>
						</el-tooltip>
						<div class="content">
							<div class="slider">
								<el-slider v-model="luminance" @change="changeLuminance" style="margin-right: 10px"
									:disabled="!currentDetail.run_state">
								</el-slider>
							</div>
							<div class="input">
								<el-input-number class="input" size="mini" v-model="cluminance"
									controls-position="right" @change="changeCluminance" :min="0" :max="100"
									:disabled="!currentDetail.run_state">
								</el-input-number>
							</div>
						</div>
					</div>
				</template>
			</div>
		</template>
		<template v-if="isDetail=='list' && isMap">
			<div class="prolist">
				<div class="pro_items">
					<div class="pro_index">{{$t('terminal.no')}}</div>
					<div class="pro_name">{{$t('terminal.proName')}}</div>
				</div>
			</div>
			<div class="prolist" v-for="(item, index) in this.current_program_list" :key="index">
				<div class="pro_items">
					<div class="pro_index">{{ index + 1 }}</div>
					<div class="pro_name">{{ item.name }}</div>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
	const detailCommand = "/admin/Command/deviceCommand";
	import timezones from "@static/data/timezones";
	import {
		uriEncode
	} from "@/assets/scripts/uriEncode";
	import {
		formatHMS,
		formatDate,
		secToHMS,
		sendCommandKp
		//daysWeek,
		//getOnlineTotal
	} from "@/assets/scripts/publicFunction";
	export default {
		name: 'DeviceDetail',
		props: {
			currentDetail: {
				type: Object,
				default: null
			},
			isMap: {
				type: Boolean,
				default: true
			}
		},
		data() {
			return {
				dcInfoCache:[],
				isDetail: 'detail',
				timeUTC: -1,
				cluminance: 0,
				luminance: 0,
				cvoice: 0,
				voice: 0,
				detailLoading: false,
				currentTimeZoneId: 0,
				timezonesList: timezones,
				imgloading: false,
				isImgDelete: false,
				detailImg: '',
				timeOut: 60,
				refreshIMG: null,
				current_program_list: []
			}
		},
		methods: {
			saveVoice() {
				let commands_info = [{
					device_id: this.currentDetail.id,
					sn: this.currentDetail.sn,
					msg: {
						id: this.currentDetail.id,
						data: {
							value: (this.voice / 100).toFixed(2),
						},
						type: "voice",
					},
				}, ];
				this.$http.post(
					detailCommand, {
						commands_info: uriEncode(commands_info),
					},
					(data) => {
						console.log(data);
					}
				);
			},
			saveBright() {
				let commands_info = [{
					device_id: this.currentDetail.id,
					sn: this.currentDetail.sn,
					msg: {
						id: this.currentDetail.id,
						data: {
							value: this.luminance,
						},
						type: "bright",
					},
				}, ];

				this.$http.post(
					detailCommand, {
						commands_info: uriEncode(commands_info),
					},
					(data) => {
						console.log(data);
					}
				);
			},
			getPlayList() {
				if (this.currentDetail.run_state) {
					let user_id = this.$cookies.get("user_id");
					//this.detail_list_loading = true;
					//this.playListLoad = true;
					this.$http.post(detailCommand, {
						commands_info: uriEncode([{
							device_id: this.currentDetail.id,
							sn: this.currentDetail.sn,
							msg: {
								id: this.currentDetail.id,
								sn: this.currentDetail.sn,
								groupName: user_id,
								type: "get_program_list",
							},
						}, ]),
					});

				}
			},
			changeDetail(val) {
				this.isDetail = val;
				if (val == 'list') {
					this.getPlayList();
					this.myWebSocket.onmessage = (val) => {
						if (JSON.parse(val.data).type == 'get_program_list') {
							let data = JSON.parse(val.data);
							let program_list = data.data.data;
							this.current_program_list = program_list;
							//this.detail_list_loading = false;
							//this.playListLoad = false;
							//console.log("program_list", this.current_program_list);
							this.current_program_list.forEach((ele) => {
								ele.playTime = secToHMS(ele.playTime)
							})
							console.log(this.current_program_list)
						}
					}
				}
			},
			changeCvoice() {
				this.voice = Number(this.cvoice);
				this.saveVoice();
			},
			changeVoice() {
				this.cvoice = this.voice;
				this.saveVoice();
			},
			changeCluminance() {
				this.luminance = parseInt(this.cluminance);
				this.saveBright();
			},
			changeLuminance() {
				this.cluminance = this.luminance;
				this.saveBright();
			},
			async getOnlineDeviceDetail() {
				let user_id = this.$cookies.get("user_id");
				let get_device_info = true;
				let invoke_method = true;
				let get_setting_schedule = true;
				//await this.getSettingSchedule();
				this.detailLoading = true;
				this.$http.post(
					detailCommand, {
						commands_info: uriEncode([{
							device_id: this.currentDetail.id,
							sn: this.currentDetail.sn,
							msg: {
								id: this.currentDetail.id,
								sn: this.currentDetail.sn,
								groupName: user_id,
								type: "get_device_info",
							},
						}, ]),
					}
				);
				// this.$http.post("/admin/command/generalCommand", {
				// 	device_select_mode: "multiple",
				// 	devices_info: uriEncode([{
				// 		id: this.currentDetail.id,
				// 		sn: this.currentDetail.sn,
				// 		type_id: this.currentDetail.type_id,
				// 		name: this.currentDetail.name,
				// 		cache: {}
				// 	}]),
				// 	request_type: 'get',
				// 	commands_info: uriEncode([{
				// 		type: "invoke_method",
				// 		data: {
				// 			methodName: "getDeviceInfo",
				// 			methodParams: {}
				// 		}
				// 	}]),
				// });
				sendCommandKp('multiple', this.dcInfoCache, "get", {
					methodName: "getCurTime",
					methodParams: {}
				});
				this.$http.post(
					detailCommand, {
						commands_info: uriEncode([{
							device_id: this.currentDetail.id,
							sn: this.currentDetail.sn,
							msg: {
								id: this.currentDetail.id,
								sn: this.currentDetail.sn,
								groupName: user_id,
								type: "get_setting_schedule",
							},
						}, ]),
					}
				);
				sendCommandKp('multiple', this.dcInfoCache, "get", {
					methodName: "getSignalInput",
					methodParams: {}
				});
				
				sendCommandKp('multiple', this.dcInfoCache, "get", {
					methodName: "getLanguages",
					methodParams: {}
				});
				setTimeout(() => {
					if (this.detailLoading == true) {
						get_device_info = false;
						invoke_method = false;
						get_setting_schedule = false;
						this.currentDetail.uptimeMills = "暂无数据"
					}
					this.detailLoading = false;
				}, 2000)
				this.myWebSocket.onmessage = (val) => {
					let devices_info;
					//let schedule_info;
					if (JSON.parse(val.data).type == "get_device_info") {
						devices_info = JSON.parse(val.data);
						this.voice = parseInt(devices_info.data.device.voice * 100);
						this.luminance = devices_info.data.bright;
						this.cluminance = devices_info.data.bright;
						this.cvoice = parseInt(devices_info.data.device.voice * 100);
						this.subModel = devices_info.data.device.subModel;
						this.currentDetail.totalSpace =
							devices_info.data.device.totalSpace;
						this.currentDetail.usableSpace =
							devices_info.data.device.usableSpace;
						this.currentDetail.uptimeMills = formatHMS(
							devices_info.data.uptimeMills,
							":",
							false,
							false
						);
						this.currentDetail.remote_addr = devices_info.data.device.remote_addr; //老的ip地址
						if (devices_info.data.time === "0") {
							this.currentDetail.time = "--";
						} else {
							this.currentDetail.time = formatDate(
								new Date(devices_info.data.time),
								"yyyy-MM-dd hh:mm:ss"
							);
						}
						if (this.currentDetail.last_heartbeat == 0) {
							this.currentDetail.last_heartbeat = "-1";
						} else {
							//console.log('heart', typeof this.currentDetail.last_heartbeat)
							this.currentDetail.last_heartbeat =
								typeof this.currentDetail.last_heartbeat == "number" ?
								formatDate(
									new Date(this.currentDetail.last_heartbeat * 1000),
									"yyyy-MM-dd hh:mm:ss"
								) :
								this.currentDetail.last_heartbeat;
						}
						get_device_info = false;
						this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
					} else if (JSON.parse(val.data).type == "invoke_method") {
						let data = JSON.parse(val.data);

						if (data.data.uri === "getCurTime" && data.data.response != undefined) {
							let utc = JSON.parse(data.data.response)
							this.currentTimeZoneId = utc.timeZoneId;
							this.timezonesList.forEach((val) => {
								if (val.id == this.currentTimeZoneId) {
									this.timeUTC = val.label;
								}
							})
							invoke_method = false;
							this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
						}

						if (data.data.uri === "getSignalInput") {
							let signInput = JSON.parse(data.data.response)
							this.currentDetail.sign_input = signInput.input;
							console.log(signInput)
						}
						
						if (data.data.uri === "getLanguages") {
							let langList = JSON.parse(data.data.response)
							this.currentDetail.deviceLan = langList.data[0].zhName;
						}

						// if(data.data.uri === 'getDeviceInfo') {
						// 	let dcInfo = JSON.parse(data.data.response);
						// 	let dcArray = dcInfo.data.split('\n'); //由于返回的是字符串,根据换行分成数组
						// 	this.currentDetail.remote_addr = dcArray[1].split('：')[1];//这里对方用的中文字符串:
						// 	this.currentDetail.timing_play = dcArray[5].split('：')[1];//定时播放
						// 	this.currentDetail.sync_play = dcArray[7].split('：')[1] //同步播放
						// 	console.log(dcArray);  
						// }

					} else if (JSON.parse(val.data).type == "get_setting_schedule") {
						let schedule_info;
						schedule_info = JSON.parse(val.data);
						this.currentDetail.timeOnOff = schedule_info.data;
						get_setting_schedule = false;
						this.detailLoading = get_device_info || invoke_method || get_setting_schedule;
					}
				};

			},
			getDetailCaputerImg(type) {
				this.imgloading = true;
				this.$http.post("/admin/command/capture", {
					command: type,
					devices_info: uriEncode([{
						id: this.currentDetail.id,
						sn: this.currentDetail.sn,
						type_id: this.currentDetail.type_id,
					}, ]),
				}, data => {
					if (data.length == 0) {
						this.isImgDelete = true;
					}
				});
			},
			innerImg() {
				this.deleteInter = setInterval(() => {
					if (this.isImgDelete == true) {
						this.$nextTick(() => {
							let url =
								"/upload/capture/d_" +
								this.currentDetail.id +
								"/" +
								"device_" +
								this.currentDetail.id +
								"_capture.png?t=" +
								new Date().getTime();
							var temp = new Image();
							temp.src = url;
							temp.onload = () => {
								this.detailImg = url;
								this.imgloading = false;
								clearInterval(this.deleteInter)
							};
							temp.onerror = () => {
								//
							}
						});
					}
				}, 1000);
			},
			interImg() {
				this.refreshIMG = setInterval(() => {
					this.timeOut -= 1;
					if (this.timeOut == 0) {
						this.getDetailCaputerImg("capture");
						this.innerImg();
						this.timeOut = 60;
					}
				}, 1000)
				this.$once('hook:beforeDestroy', () => {
					clearInterval(this.refreshIMG);
					clearInterval(this.deleteInter);
					this.refreshIMG = null;
					this.deleteInter = null;
				})
			}
		},
		computed: {
			myWebSocket() {
				return this.$store.getters.myWebSocket;
			},
		},
		created() {
			this.dcInfoCache = [{
				id: this.currentDetail.id,
				sn: this.currentDetail.sn,
				type_id: this.currentDetail.type_id,
				name: this.currentDetail.name,
				cache: {}
			}];
			if (this.currentDetail != null) {
				this.currentDetail.uptimeMills = "暂无数据";
				if (this.currentDetail.system_version != null) {
					if (this.currentDetail.run_state) {
						this.getOnlineDeviceDetail();
						this.getDetailCaputerImg("capture");
						this.innerImg();
						this.interImg();
					} else {
						clearInterval(this.refreshIMG);
						this.refreshIMG = null;
					}
				}
			}
		},
		watch: {
			currentDetail() {
				if (this.currentDetail != null) {
					this.timeUTC = -1;
					this.cluminance = 0;
					this.luminance = 0;
					this.cvoice = 0;
					this.voice = 0;
					this.current_program_list = [];
					this.isDetail = 'detail';
					this.currentDetail.uptimeMills = "暂无数据";
					if (this.currentDetail.system_version != null) {
						if (this.currentDetail.run_state) {
							clearInterval(this.refreshIMG);
							this.refreshIMG = null;
							clearInterval(this.deleteInter);
							this.deleteInter = null;
							this.getOnlineDeviceDetail();
							setTimeout(() => {
								this.getDetailCaputerImg("capture");
								this.innerImg();
							}, 100)
							this.timeOut = 60;
							//this.interImg();
						} else {
							clearInterval(this.refreshIMG);
							this.refreshIMG = null;
							clearInterval(this.deleteInter);
							this.deleteInter = null;
						}
					}
					if (this.currentDetail.last_heartbeat == 0) {
						this.currentDetail.last_heartbeat = "-1";
					} else {
						//console.log('heart', typeof this.currentDetail.last_heartbeat)
						this.currentDetail.last_heartbeat =
							typeof this.currentDetail.last_heartbeat == "number" ?
							formatDate(
								new Date(this.currentDetail.last_heartbeat * 1000),
								"yyyy-MM-dd hh:mm:ss"
							) :
							this.currentDetail.last_heartbeat;
					}
				}
			}
		}
	}
</script>

<style lang="scss" scoped>
	.device-detail {
		width: 100%;
		height: 100%;
		border-radius: 0 8px 8px 0;

		.prolist {
			display: flex;
			width: 100%;

			.pro_items {
				display: flex;
				align-items: center;
				width: 100%;
				height: 30px;
				border-bottom: 1px solid #e2e5ea;
				white-space: nowrap;

				.pro_index {
					width: 50%;
					line-height: 30px;
					text-align: center;
				}

				.pro_name {
					width: 50%;
					line-height: 30px;
					text-align: center;
					overflow: hidden;
					text-overflow: ellipsis;
				}
			}
		}

		.button {
			width: 100%;
			height: 40px;
			display: flex;

			div {
				width: 50%;
				height: 40px;
				line-height: 40px;
				text-align: center;
				cursor: pointer;
			}

			.detailActive {
				// background-image: linear-gradient(270deg,
				// 		#72e0ea 0%,
				// 		#59d3ee 45%,
				// 		#40c6f1 100%),
				// 	linear-gradient(#42c6f1, #42c6f1);
				// background-blend-mode: normal, normal;
				background-color: var(--theme-color-customized-1);
				color: #ffffff;
			}

		}

		.caputer {
			margin: 20px auto;
			background-color: black;
			width: 98%;
			padding-bottom: 52.25%;
			position: relative;

			.img {
				width: 100%;
				height: 100%;
				position: absolute;
				left: 0;
				bottom: 0;
			}
		}

		.mapCaputer {
			margin: 0;
			width: 250px;
		}

		.isMap {
			height: 300px;
			max-height: 300px;
			width: 250px;
			background-color: white;
			overflow: auto;

			.b_border_map {
				height: 25px;
				line-height: 25px;
				margin: 0 auto;
				padding: 0;

				//background-color: orange;
				.text {
					line-height: 25px;
				}
			}
		}

		.details {
			height: calc(100% - 40px - 142px - 40px);
			overflow-y: auto;

			.b_border {
				width: 90%;
				padding: 2px;
				margin: 5px auto;
				border-bottom: 1px solid #e2e5ea;
				height: 30px;
				display: flex;
				align-items: center;

				.text {
					width: 100px;
					height: 100%;
					line-height: 30px;
					text-align: right;
					white-space: nowrap;
				}

				.content {
					width: calc(100% - 110px);
					padding-left: 5px;
					//display: flex;
					align-items: center;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;

					.slider {
						width: 40%;
					}

					.input {
						width: 80px;
					}
				}
			}

			.block {
				display: flex;
				width: 90%;
				margin: 5px auto;
				align-items: center;
				height: 30px;

				.text {
					width: 80px;
					height: 100%;
					line-height: 30px;
					text-align: right;
				}

				.content {
					width: calc(100% - 110px);
					padding-left: 10px;
					height: 100%;
					display: flex;
					align-items: center;
				}

				.slider {
					width: calc(100% - 70px);
				}

				.input {
					width: 70px;

					/deep/ .el-input__inner {
						padding-left: 5px;
						padding-right: 40px;
					}
				}
			}
		}
	}
</style>
